import { ReactNode } from 'react';
import './ModuleActionSurface.scss';

type ModuleActionSurfaceProps = {
	label: string;
	className?: string;
	disabled?: boolean;
	trailingIcon?: ReactNode;
};

const ModuleActionSurface = ({ label, className, disabled, trailingIcon }: ModuleActionSurfaceProps) => {
	const classes = ['biz-module', 'biz-module-action-surface'];

	if (className) {
		classes.push(className);
	}

	if (disabled) {
		classes.push('biz-module-action-surface--disabled');
	}

	return (
		<div className={classes.join(' ')}>
			<span className='biz-module-action-surface__label'>{label}</span>
			{trailingIcon && <span className='biz-module-action-surface__icon'>{trailingIcon}</span>}
		</div>
	);
};

export default ModuleActionSurface;
